export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error('Error setting item:', error);
    return false;
  }
};

export const getItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);

    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Error getting item:', error);
    return defaultValue;
  }
};

export const removeItem = key => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Error removing item:', error);
    return false;
  }
};

export const clearAll = () => {
  try {
    localStorage.clear();
    return true;
  } catch (error) {
    console.error('Error clearing all items:', error);
    return false;
  }
};

export default {
  setItem,
  getItem,
  removeItem,
  clearAll,
};
